export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-background-50 font-heading text-lg font-bold">
                私密视频播放器
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              私密视频播放器为您整合香蕉视频、红桃视频、91视频、蜜桃视频等热门视频平台入口，
              提供全面的在线视频平台导航与视频大全服务。做您最便捷的视频网站导航伙伴。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-100 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">视频平台大全</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门排行</a></li>
              <li><a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">精选专题</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-100 mb-4">更多信息</h3>
            <ul className="space-y-2.5">
              <li><a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">最新动态</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              我们与多家优质在线视频平台保持良好的导航合作关系，持续为用户提供可靠的视频平台入口与最新资讯。合作伙伴信息持续更新中。
            </p>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 私密视频播放器 - 热门视频平台大全与在线视频导航
          </p>
          <p className="text-xs text-background-600">
            本站仅提供平台导航服务，不存储、不传播任何视频内容
          </p>
        </div>
      </div>
    </footer>
  );
}